export const FONT_LIST_REQUEST = "FONT_LIST_REQUEST";
export const FONT_LIST_SUCCESS = "FONT_LIST_SUCCESS";
export const FONT_LIST_FAIL = "FONT_LIST_FAIL";

export const FONT_DETAIL_REQUEST = "FONT_DETAIL_REQUEST";
export const FONT_DETAIL_SUCCESS = "FONT_DETAIL_SUCCESS";
export const FONT_DETAIL_FAIL = "FONT_DETAIL_FAIL";
